/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/helpers/format-money.js":
/*!****************************************!*\
  !*** ./src/js/helpers/format-money.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/imports/slider-component.js":
/*!********************************************!*\
  !*** ./src/js/imports/slider-component.js ***!
  \********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SliderComponent = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SliderComponent, _HTMLElement);
  var _super = _createSuper(SliderComponent);
  function SliderComponent() {
    var _this;
    _classCallCheck(this, SliderComponent);
    _this = _super.call(this);
    _this.slider = _this.querySelector('[id^="Slider-"]');
    _this.sliderItems = _this.querySelectorAll('[id^="Slide-"]');
    _this.enableSliderLooping = false;
    _this.currentPageElement = _this.querySelector('.slider-counter--current');
    _this.pageTotalElement = _this.querySelector('.slider-counter--total');
    _this.prevButton = _this.querySelector('button[name="previous"]');
    _this.nextButton = _this.querySelector('button[name="next"]');
    if (!_this.slider || !_this.nextButton) return _possibleConstructorReturn(_this);
    _this.initPages();
    var resizeObserver = new ResizeObserver(function (entries) {
      return _this.initPages();
    });
    resizeObserver.observe(_this.slider);
    _this.slider.addEventListener('scroll', _this.update.bind(_assertThisInitialized(_this)));
    _this.prevButton.addEventListener('click', _this.onButtonClick.bind(_assertThisInitialized(_this)));
    _this.nextButton.addEventListener('click', _this.onButtonClick.bind(_assertThisInitialized(_this)));
    return _this;
  }
  _createClass(SliderComponent, [{
    key: "initPages",
    value: function initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (element) {
        return element.clientWidth > 0;
      });
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  }, {
    key: "resetPages",
    value: function resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  }, {
    key: "update",
    value: function update() {
      // Temporarily prevents unneeded updates resulting from variant changes
      // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
      if (!this.slider || !this.nextButton) return;
      var previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }
      if (this.enableSliderLooping) return;
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }, {
    key: "isSlideVisible",
    value: function isSlideVisible(element) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(event) {
      event.preventDefault();
      var step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.setSlidePosition(this.slideScrollPosition);
    }
  }, {
    key: "setSlidePosition",
    value: function setSlidePosition(position) {
      this.slider.scrollTo({
        left: position
      });
    }
  }]);
  return SliderComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('slider-component', SliderComponent);

/***/ }),

/***/ "./src/js/modules/ed-cart-upsell.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-cart-upsell.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CartUpsellItem = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CartUpsellItem, _HTMLElement);
  var _super = _createSuper(CartUpsellItem);
  function CartUpsellItem() {
    _classCallCheck(this, CartUpsellItem);
    return _super.apply(this, arguments);
  }
  _createClass(CartUpsellItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();

      //document.querySelector('.js-drawer-open-cart').click();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAtc = this.querySelector('[data-btn-atc]');
      this.productData = JSON.parse(this.querySelector('[type="application/json"]').innerHTML);
      this.optionItems = this.querySelectorAll('select');
      this.upsellImage = this.querySelector('img[data-upsell-img]');
      this.price = this.querySelector('[data-upsell-price]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.btnAtc.addEventListener('click', this.onBtnAddToCart.bind(this));
      this.optionItems.forEach(function (item) {
        item.addEventListener('change', _this.onOptionItemChange.bind(_this));
      });
    }
  }, {
    key: "onOptionItemChange",
    value: function onOptionItemChange(e) {
      var selectedVariant = this._findVariant(this.optionItems);

      // update image
      if (this.upsellImage.src !== selectedVariant.featured_media) {
        this.upsellImage.src = selectedVariant.featured_media;
      }

      // update price
      if (this.price !== selectedVariant.price) {
        this.price.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(selectedVariant.price, '{{amount_with_comma_separator}}€');
      }
    }
  }, {
    key: "onBtnAddToCart",
    value: function onBtnAddToCart(e) {
      e.preventDefault();
      this.setAttribute('ed-loading', 'true');
      var variant = this._findVariant(this.optionItems);
      this.addVariantToCart(variant.id);
    }
  }, {
    key: "addVariantToCart",
    value: function addVariantToCart(id) {
      var _this2 = this;
      var itemAdd = [];
      var item = {
        id: id,
        quantity: 1,
        properties: {
          '_upsell-item': true
        }
      };
      itemAdd.push(item);
      var formData = {
        'items': itemAdd,
        quantity: 1
      };
      fetch("/cart/add.js", {
        body: JSON.stringify(formData),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (addedItemsData) {
        _this2.onUpsellItemAdded(addedItemsData);
        _this2.removeAttribute('ed-loading');
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }, {
    key: "onUpsellItemAdded",
    value: function onUpsellItemAdded() {
      setTimeout(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
          bubbles: true
        }));
      }, 1000);
    }
  }, {
    key: "_findVariant",
    value: function _findVariant(optionItems) {
      var selectedOptions = Array.from(optionItems).map(function (item) {
        return item.value;
      });
      var matchingVariant = this.productData.find(function (variant) {
        if (selectedOptions.length === 1) {
          return variant.option1 === selectedOptions[0];
        } else if (selectedOptions.length === 2) {
          return variant.option1 === selectedOptions[0] && variant.option2 === selectedOptions[1];
        } else if (selectedOptions.length === 3) {
          return variant.option1 === selectedOptions[0] && variant.option2 === selectedOptions[1] && variant.option3 === selectedOptions[2];
        }
      });
      return matchingVariant;
    }
  }]);
  return CartUpsellItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-upsell-item', CartUpsellItem);

/***/ }),

/***/ "./src/js/modules/ed-free-gift-handling.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-free-gift-handling.js ***!
  \*************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FreeGiftHandling = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FreeGiftHandling, _HTMLElement);
  var _super = _createSuper(FreeGiftHandling);
  function FreeGiftHandling() {
    _classCallCheck(this, FreeGiftHandling);
    return _super.apply(this, arguments);
  }
  _createClass(FreeGiftHandling, [{
    key: "cartType",
    get: function get() {
      return this.getAttribute('cart-type');
    }
  }, {
    key: "discountType",
    get: function get() {
      return this.getAttribute('discount-type');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.debugMode = false; // Change this value as needed

      this.cartItems = JSON.parse(this.getAttribute('cart-items')) || [];
      this.isGiftAlreadyInCart = this.getAttribute('gift-already-in-cart');
      this._attachListeners();
      this._attachSelectors();
      if (this.cartType === 'drawer') {
        document.addEventListener('cart:updated', this.onCartChange.bind(this));
        document.addEventListener('ajaxProduct:added', this.onProductAdded.bind(this));
        if (this.progressBar) {
          setTimeout(function () {
            // make sure cartTotal and threshold are updated
            document.addEventListener('cart:updated', _this.initProgressBar.bind(_this));
          });
        }
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cartTotal = this.getAttribute('cart-total');
      this.threshold = this.getAttribute('threshold');
      this.eligibleProducts = this.getAttribute('eligible-products-ids');
      this.freeGiftItems = this.getAttribute('free-gift-ids');
      if (this.discountType === 'minimum_quantity') {
        this.cartQuantity = this.getAttribute('cart-quantity'); // important note: this attribute is only made for counting eligible products
      }

      /** Progress Bar **/
      document.addEventListener('ed:progress-bar:loaded', function () {
        // need to wait for the progress bar to load
        this.progressBar = document.querySelector('ed-free-gift-progress-bar');
        if (this.progressBar) {
          this.initProgressBar();
        }
      }.bind(this));
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('DOMContentLoaded', this.initFreeGifts.bind(this));
    }
  }, {
    key: "onCartChange",
    value: function onCartChange(e) {
      if (e) {
        var cart = e.detail.cart;
        this.cartTotal = cart.total_price;
        this.cartItems = cart.items;
      }
      if (this.discountType === 'minimum_quantity') {
        this.cartQuantity = this.countEligibleCartQuantity(this.cartItems, this.eligibleProducts);
      }

      /*
      console.log('cart total', this.cartTotal);
      console.log('cart items', this.cartItems);
      console.log('cart Quantity', this.cartQuantity);
       */

      this.isGiftAlreadyInCart = this.checkIsGiftAlreadyInCart(this.cartItems);
      if (!this.isGiftAlreadyInCart) {
        this.initFreeGifts();
      }
    }
  }, {
    key: "onProductAdded",
    value: function onProductAdded(e) {
      var addedLine = e.detail.product;
      var index = this.cartItems.findIndex(function (item) {
        return item.id === addedLine.id;
      });
      if (index !== -1) {
        // Item found, replace the object
        this.cartItems[index] = addedLine;
      } else {
        // Item not found, add to the array
        this.cartItems.push(addedLine);
      }

      // NOTE: ONLY WORKS IN SINGLE ADD
      this.cartTotal = parseInt(this.cartTotal) + addedLine.price;
      this.onCartChange();

      /** FETCH REQUEST WAY **/
      /**
       fetch('/cart.js')
       .then(response => response.json())
       .then(data => {
       this.onCartChange({
       detail: {
       cart: data
       }
       })
       })
       * */
    }
  }, {
    key: "checkIsGiftAlreadyInCart",
    value: function checkIsGiftAlreadyInCart(cartItems) {
      var freeGiftIds = this.freeGiftItems.split(',');
      return cartItems.some(function (item) {
        return freeGiftIds.includes(item.id.toString());
      });
    }
  }, {
    key: "initFreeGifts",
    value: function initFreeGifts() {
      var isThresholdReached;
      switch (this.discountType) {
        case 'minimum_price':
          isThresholdReached = this.isMinimumPriceReached(this.cartTotal, this.threshold);
          break;
        case 'minimum_quantity':
          isThresholdReached = this.isMinimumQuantityReached(this.cartQuantity, this.threshold);
          break;
      }
      if (sessionStorage.getItem('ed_free_gift_added') && !this.debugMode) {
        return;
      }
      if (!isThresholdReached || this.isGiftAlreadyInCart) {
        return;
      }
      this.addFreeGifts(this.freeGiftItems);
    }
  }, {
    key: "isMinimumPriceReached",
    value: function isMinimumPriceReached(cartTotal, threshold) {
      return parseInt(cartTotal) >= parseInt(threshold);
    }
  }, {
    key: "isMinimumQuantityReached",
    value: function isMinimumQuantityReached(cartQuantity, minimumQuantity) {
      return parseInt(cartQuantity) >= parseInt(minimumQuantity);
    }
  }, {
    key: "countEligibleCartQuantity",
    value: function countEligibleCartQuantity(cartItems, eligibleProducts) {
      eligibleProducts = eligibleProducts.split(',');
      var totalEligibleQuantity = 0;

      // Iterate over each item in cartItems
      cartItems.forEach(function (item) {
        // Check if the current item's ID is in the eligibleProducts array
        if (eligibleProducts.includes(item.product_id.toString())) {
          // Add the item's quantity to the total eligible quantity
          totalEligibleQuantity += item.quantity;
        }
      });
      return totalEligibleQuantity;
    }
  }, {
    key: "countEligibleCartQuantityOnAddedFreeGifts",
    value: function countEligibleCartQuantityOnAddedFreeGifts(items, eligibleProducts) {
      eligibleProducts = eligibleProducts.split(',');
      var matchingItemCount = 0;

      // Iterate over each item in addedItemsData
      addedItemsData.forEach(function (item) {
        // Check if the current item's ID is in the eligibleProducts array
        if (eligibleProducts.includes(item.id.toString())) {
          // Increment the counter for each matching item
          matchingItemCount++;
        }
      });

      // Return the number of matching items
      return matchingItemCount;
    }
  }, {
    key: "addFreeGifts",
    value: function addFreeGifts(items) {
      var _this2 = this;
      var itemIds = items.split(',');
      var itemAdd = [];
      itemIds.forEach(function (id) {
        var item = {
          id: id,
          quantity: 1,
          properties: {
            '_free-gift': true
          }
        };
        itemAdd.push(item);
      });
      var formData = {
        'items': itemAdd,
        quantity: 1
      };
      fetch("/cart/add.js", {
        body: JSON.stringify(formData),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (addedItemsData) {
        _this2.onFreeGiftAdded(addedItemsData);
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }, {
    key: "onFreeGiftAdded",
    value: function onFreeGiftAdded(addedItemsData) {
      // IF ADDED ITEMS IS FREE GIFT, CHANGE THE PROPERTY
      this.cartQuantity = this.cartQuantity + this.countEligibleCartQuantity(addedItemsData === null || addedItemsData === void 0 ? void 0 : addedItemsData.items, this.eligibleProducts);
      this.isGiftAlreadyInCart = this.checkIsGiftAlreadyInCart(addedItemsData.items);
      if (this.cartType === 'drawer') {
        setTimeout(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
            bubbles: true
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
            bubbles: true
          }));
        }, 1000);
      } else {
        location.reload();
      }
      this.setSessionStorageItem('ed_free_gift_added', 'true');
    }
  }, {
    key: "setSessionStorageItem",
    value: function setSessionStorageItem(key, value) {
      sessionStorage.setItem(key, value);
    }

    /** PROGRESS BAR **/
  }, {
    key: "initProgressBar",
    value: function initProgressBar() {
      var isThresholdReached;
      switch (this.discountType) {
        case 'minimum_price':
          isThresholdReached = this.isMinimumPriceReached(this.cartTotal, this.threshold);
          break;
        case 'minimum_quantity':
          isThresholdReached = this.isMinimumQuantityReached(this.cartQuantity, this.threshold);
          break;
      }
      this.milestoneItem = this.progressBar.querySelector('.milestone-item');
      if (!this.isGiftAlreadyInCart && isThresholdReached) {
        this.milestoneItem.classList.add('active');
        this.milestoneItem.addEventListener('click', this.mileStoneItemClickListener.bind(this));
      } else {
        this.milestoneItem.classList.remove('active');
        this.milestoneItem.removeEventListener('click', this.mileStoneItemClickListener.bind(this));
      }
    }
  }, {
    key: "mileStoneItemClickListener",
    value: function mileStoneItemClickListener() {
      this.addFreeGifts(this.freeGiftItems);
    }
  }]);
  return FreeGiftHandling;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-free-gift-handling', FreeGiftHandling);
var FreeGiftProgressBar = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(FreeGiftProgressBar, _HTMLElement2);
  var _super2 = _createSuper(FreeGiftProgressBar);
  function FreeGiftProgressBar() {
    _classCallCheck(this, FreeGiftProgressBar);
    return _super2.apply(this, arguments);
  }
  _createClass(FreeGiftProgressBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachListeners();
      this._attachSelectors();
      document.dispatchEvent(new CustomEvent('ed:progress-bar:loaded'));
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {}
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {}
  }]);
  return FreeGiftProgressBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-free-gift-progress-bar', FreeGiftProgressBar);

/***/ }),

/***/ "./src/js/modules/ed-product-video-component.js":
/*!******************************************************!*\
  !*** ./src/js/modules/ed-product-video-component.js ***!
  \******************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);
  var _super = _createSuper(EdVideoThumbnail);
  function EdVideoThumbnail() {
    _classCallCheck(this, EdVideoThumbnail);
    return _super.apply(this, arguments);
  }
  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();

      // ENABLE EXTERNAL POPUP ELEMENT
      if (this.popUp) {
        document.querySelector('ed-video-popup').setAttribute('enabled', '');
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.popUp = document.querySelector('.video-popup-container');
      this.popUpVideo = this.popUp.querySelector('.video-container'); // video inside of popup

      this.openButton = this.querySelector('.btn-open');
      //this.playButton = this.querySelector('.play-btn'); // OPTIONAL SECOND BUTTON
      this.closeButton = this.popUp.querySelector('.btn-close');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this));
      //this.playButton.addEventListener('click', this.openPopup.bind(this));

      // click outside
      this.popUp.addEventListener('click', this.closePopup.bind(this));
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;

      /** settings **/
      video.autoplay = true;
      video.controls = true;
      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }
      if (this.controls === 'false') {
        video.controls = false;
      }
      this.popUpVideo.appendChild(video);
    }
  }]);
  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-video-thumbnail', EdVideoThumbnail);
var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);
  var _super2 = _createSuper(EdVideoPopup);
  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);
    return _super2.apply(this, arguments);
  }
  _createClass(EdVideoPopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {}
  }]);
  return EdVideoPopup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-video-popup', EdVideoPopup);

/***/ }),

/***/ "./src/js/modules/jo-gwp-main.js":
/*!***************************************!*\
  !*** ./src/js/modules/jo-gwp-main.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var JoGwpMain = /*#__PURE__*/function (_HTMLElement) {
  _inherits(JoGwpMain, _HTMLElement);
  var _super = _createSuper(JoGwpMain);
  function JoGwpMain() {
    _classCallCheck(this, JoGwpMain);
    return _super.apply(this, arguments);
  }
  return _createClass(JoGwpMain);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('jo-gwp-main', JoGwpMain);
var JoGwpProgressBar = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(JoGwpProgressBar, _HTMLElement2);
  var _super2 = _createSuper(JoGwpProgressBar);
  function JoGwpProgressBar() {
    _classCallCheck(this, JoGwpProgressBar);
    return _super2.apply(this, arguments);
  }
  _createClass(JoGwpProgressBar, [{
    key: "cartTotal",
    get:
    /* -------------------------
    CLEAN GETTERS FOR ATTRS
    ------------------------- */

    function get() {
      return Number(this.getAttribute('cart-total') || 0);
    }
  }, {
    key: "targets",
    get: function get() {
      var raw = this.getAttribute('data-targets') || '';
      return raw.split(',').map(function (v) {
        return Number(v.trim());
      }).filter(function (v) {
        return !isNaN(v) && v > 0;
      }); // 0 & Müll raus
    }
  }, {
    key: "textTemplates",
    get: function get() {
      var raw = this.getAttribute('data-texts') || '';
      return raw.split('||SEP||').map(function (t) {
        return t.trim();
      }).filter(Boolean);
    }
  }, {
    key: "textAllReached",
    get: function get() {
      return this.getAttribute('text-all-milestones-reached') || 'Alle Meilensteine erreicht!';
    }
  }, {
    key: "removeItemsAttr",
    get: function get() {
      return (this.getAttribute('rm-items') || '').trim();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.calculateProgress();
      this.autoRemoveFreeGifts();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.messageContainer = this.querySelector('[data-progress-bar-message]');
      this.currentProgress = this.querySelector('[data-current-progress]');
      this.milestoneIcons = Array.from(this.querySelectorAll('[data-milestone-icon]:not(.pseudo)'));

      // cart remove handling
      this.cartRemoveButtons = document.querySelectorAll('.cart__remove[data-jo-btn-rm]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.cartRemoveButtons.forEach(function (removeButton) {
        removeButton.addEventListener('click', _this.onCartBtnRemove.bind(_this));
      });
    }

    /* -------------------------
       MAIN LOGIC
       ------------------------- */
  }, {
    key: "calculateProgress",
    value: function calculateProgress() {
      var total = this.cartTotal;
      var targets = this.targets;
      if (!this.currentProgress || targets.length === 0) return;
      console.log('total', total, targets);
      var maxTarget = targets.at(-1);
      var progressPercent = 0;
      if (total >= maxTarget) {
        progressPercent = 100;
      } else {
        for (var i = 0; i < targets.length; i++) {
          var next = targets[i];
          var prev = targets[i - 1] || 0;
          if (total < next) {
            var sectionPercent = 100 / targets.length;
            var range = next - prev;
            var withinRange = total - prev;
            progressPercent = i * sectionPercent + withinRange / range * sectionPercent;
            break;
          }
        }
      }
      this.currentProgress.style.width = "".concat(progressPercent, "%");
      this.updateMilestoneIcons(targets, total);
      this.updateProgressMessage(targets, total);
    }
  }, {
    key: "updateMilestoneIcons",
    value: function updateMilestoneIcons(targets, total) {
      this.milestoneIcons.forEach(function (icon, index) {
        var target = targets[index];
        icon.classList.toggle('reached', total >= target);
      });
    }
  }, {
    key: "updateProgressMessage",
    value: function updateProgressMessage(targets, total) {
      var container = this.messageContainer;
      if (!container) return;
      var maxTarget = targets.at(-1);

      // Alles erreicht
      if (total >= maxTarget) {
        container.textContent = this.textAllReached;
        return;
      }

      // Index des nächsten Ziels
      var nextIndex = targets.findIndex(function (t) {
        return total < t;
      });
      var nextTarget = targets[nextIndex];
      var missing = Math.max(0, nextTarget - total);

      // Template ziehen
      var template = this.textTemplates[nextIndex] || 'Nur noch ((missingamount))€ bis zum Geschenk!';
      var missingFormatted = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(missing, '{{amount_with_comma_separator}}€');
      container.innerHTML = template.replace('((missingamount))', "<span data-missing-amount>".concat(missingFormatted, "</span>"));
    }
  }, {
    key: "onCartBtnRemove",
    value: function onCartBtnRemove(e) {
      var _target$dataset;
      e.preventDefault();
      var target = e.currentTarget;
      if (target && (_target$dataset = target.dataset) !== null && _target$dataset !== void 0 && _target$dataset.joBtnRm) {
        this.removeFreeGifts(target.dataset.joBtnRm);
      }
    }

    /* -------------------------
    SAFETY
    ------------------------- */
  }, {
    key: "autoRemoveFreeGifts",
    value: function autoRemoveFreeGifts() {
      var items = this.removeItemsAttr;
      if (!items) return;
      this.removeFreeGifts(items);
    }
  }, {
    key: "removeFreeGifts",
    value: function removeFreeGifts(items) {
      var itemIds = String(items).split(',').map(function (id) {
        return id.trim();
      }).filter(Boolean);
      if (!itemIds.length) {
        console.warn('GWP: Keine gültigen IDs in removeFreeGifts');
        return;
      }
      var updates = {};
      itemIds.forEach(function (id) {
        updates[id] = 0;
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates
        })
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        console.log('GWP: Free gifts removed', data);
        document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
          bubbles: true
        }));
      })["catch"](function (err) {
        return console.error('GWP remove error:', err);
      });
    }
  }]);
  return JoGwpProgressBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('jo-gwp-progress-bar', JoGwpProgressBar);
var JoGwpItem = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(JoGwpItem, _HTMLElement3);
  var _super3 = _createSuper(JoGwpItem);
  function JoGwpItem() {
    _classCallCheck(this, JoGwpItem);
    return _super3.apply(this, arguments);
  }
  _createClass(JoGwpItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._isLoading = false;
      this._attachSelectors();
      this._attachListeners();
      if (this.getAttribute('auto-add')) {
        this.addFreeGifts(this.getAttribute('auto-add'));
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _this$popup;
      this.btnOpenPopup = this.querySelector('[data-open-popup]');
      this.popup = this.querySelector('[data-gwp-item-popup]');
      this.popupContent = (_this$popup = this.popup) === null || _this$popup === void 0 ? void 0 : _this$popup.querySelector('[data-popup-content]');
      this.addGwpButtons = this.querySelectorAll('[data-add-gwp]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      if (this.getAttribute('disable_popup') !== 'true') {
        var _this$btnOpenPopup;
        (_this$btnOpenPopup = this.btnOpenPopup) === null || _this$btnOpenPopup === void 0 || _this$btnOpenPopup.addEventListener('click', this.handleOpenPopup.bind(this));
      }
      this.popup.addEventListener('click', this.onPopupClick.bind(this));
      this.addGwpButtons.forEach(function (button) {
        button.addEventListener('click', _this2.handleAddGwp.bind(_this2));
      });
    }
  }, {
    key: "handleAddGwp",
    value: function handleAddGwp(e) {
      e.preventDefault();
      if (this._isLoading) {
        console.warn('GWP: addFreeGifts already in progress, ignoring click');
        return;
      }
      var item = e.currentTarget;
      var variantId = item.dataset.variantId;
      if (!variantId) {
        console.warn('GWP: Keine variantId auf data-attribute gefunden');
        return;
      }
      this._isLoading = true;

      // addFreeGifts erwartet aktuell einen Komma-String → ein einzelner Wert reicht
      this.addFreeGifts(variantId);
    }
  }, {
    key: "addFreeGifts",
    value: function addFreeGifts(items) {
      var _this3 = this;
      // items kann "12345" oder "12345,67890" sein
      var itemIds = String(items).split(',').map(function (id) {
        return id.trim();
      }).filter(Boolean);
      if (!itemIds.length) {
        console.warn('GWP: Keine gültigen IDs in addFreeGifts');
        return;
      }

      // 🔑 hier die Logik für _show-btn-rm-cart
      var isAutoAdd = this.getAttribute('auto-add');
      var showBtnRmCartAttr = this.getAttribute('show-btn-rm-cart');
      var showBtnRmCart = isAutoAdd ? null : showBtnRmCartAttr;
      var itemAdd = itemIds.map(function (id) {
        return {
          id: id,
          quantity: 1,
          properties: {
            '_free-gift': true,
            '_free-gift-idx': _this3.getAttribute('idx'),
            '_show-btn-rm-cart': showBtnRmCart
          }
        };
      });
      var formData = {
        items: itemAdd
      };
      fetch("/cart/add.js", {
        body: JSON.stringify(formData),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (addedItemsData) {
        var _this3$onFreeGiftAdde;
        (_this3$onFreeGiftAdde = _this3.onFreeGiftAdded) === null || _this3$onFreeGiftAdde === void 0 || _this3$onFreeGiftAdde.call(_this3, addedItemsData); // falls Methode existiert
      })["catch"](function (e) {
        console.error('GWP add error:', e);
      })["finally"](function () {
        _this3._isLoading = false;
      });
    }
  }, {
    key: "onFreeGiftAdded",
    value: function onFreeGiftAdded(addedItemsData) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
        bubbles: true
      }));
      this.closePopup();
    }

    /** POPUP METHODS **/
  }, {
    key: "handleOpenPopup",
    value: function handleOpenPopup(e) {
      e.preventDefault();
      if (this.dataset.reached !== 'true') return;
      if (!this.popup) return;
      if (this.popup.parentElement !== document.body) {
        document.body.appendChild(this.popup);
      }
      this.popup.classList.add('is-active');
    }
  }, {
    key: "onPopupClick",
    value: function onPopupClick(e) {
      e.stopPropagation();
      if (this.popupContent && this.popupContent.contains(e.target)) {
        return;
      }

      // Klick außerhalb des Dialogs (also auf den Hintergrund / Container) → schließen
      this.closePopup();
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.popup.classList.remove('is-active');
    }
  }]);
  return JoGwpItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('jo-gwp-item', JoGwpItem);

/***/ }),

/***/ "./src/js/modules/jo-image-slider.js":
/*!*******************************************!*\
  !*** ./src/js/modules/jo-image-slider.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var JoImageSlider = /*#__PURE__*/function (_HTMLElement) {
  _inherits(JoImageSlider, _HTMLElement);
  var _super = _createSuper(JoImageSlider);
  function JoImageSlider() {
    _classCallCheck(this, JoImageSlider);
    return _super.apply(this, arguments);
  }
  _createClass(JoImageSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.highlightActiveDot();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.slider = this.querySelector('slider-component ul');

      // Initial speichern
      this.slides = this._getVisibleSlides();
      this.dots = Array.from(this.querySelectorAll('.slider-dot'));

      // textbox items
      this.textboxItems = this.querySelectorAll('.textbox-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      if (this.dots.length > 0) {
        this.dots.forEach(function (dot, idx) {
          dot.addEventListener('click', function () {
            _this.scrollToSlide(idx);
          });
        });
      }
      if (this.textboxItems.length > 0) {
        this.handleTextboxResize(this.textboxItems);
        window.addEventListener('resize', function () {
          _this.handleTextboxResize(_this.textboxItems);
        });
      }
      this.slider.addEventListener('scroll', function () {
        return _this.highlightActiveDot();
      }, {
        passive: true
      });
    }
  }, {
    key: "_getVisibleSlides",
    value: function _getVisibleSlides() {
      return Array.from(this.querySelectorAll('.slider-item')).filter(function (slide) {
        return !slide.classList.contains('hidden');
      });
    }

    /** TEXTBOX **/
  }, {
    key: "handleTextboxResize",
    value: function handleTextboxResize(items) {
      var largestTextbox = 0;
      items.forEach(function (item) {
        if (item.clientHeight > largestTextbox) {
          largestTextbox = item.clientHeight;
        }
      });
      if (this.slider.classList.contains('tb-top')) {
        this.slider.style.paddingTop = largestTextbox / 2 + "px";
      } else if (this.slider.classList.contains('tb-bottom')) {
        this.slider.style.paddingBottom = largestTextbox / 2 + 10 + "px";
      }
    }

    /** DOTS **/
  }, {
    key: "scrollToSlide",
    value: function scrollToSlide(idx) {
      // Nur bei Bedarf neu holen (z.B. wenn Slides dynamisch versteckt werden)
      this.slides = this._getVisibleSlides();
      if (!this.slides[idx]) return;
      var left = this.slides[idx].offsetLeft - this.slider.offsetLeft;
      this.slider.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }
  }, {
    key: "highlightActiveDot",
    value: function highlightActiveDot() {
      this.slides = this._getVisibleSlides(); // Optional: wenn sich Slides ändern können
      var activeIdx = 0;
      var sliderScroll = this.slider ? this.slider.scrollLeft : 0;
      this.slides.forEach(function (slide, idx) {
        if (sliderScroll >= slide.offsetLeft - slide.offsetWidth / 2) {
          activeIdx = idx;
        }
      });
      this.dots.forEach(function (dot, idx) {
        dot.classList.toggle('active', idx === activeIdx);
      });
    }
  }]);
  return JoImageSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('jo-image-slider')) {
  customElements.define('jo-image-slider', JoImageSlider);
}

/***/ }),

/***/ "./src/js/modules/jo-promo-banner.js":
/*!*******************************************!*\
  !*** ./src/js/modules/jo-promo-banner.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var JoPromoBanner = /*#__PURE__*/function (_HTMLElement) {
  _inherits(JoPromoBanner, _HTMLElement);
  var _super = _createSuper(JoPromoBanner);
  function JoPromoBanner() {
    _classCallCheck(this, JoPromoBanner);
    return _super.apply(this, arguments);
  }
  _createClass(JoPromoBanner, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.discountElement = this.querySelector('[data-discount-code]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.discountElement) {
        this.discountElement.addEventListener('click', this.onDiscountElementClick.bind(this));
      }
    }
  }, {
    key: "onDiscountElementClick",
    value: function () {
      var _onDiscountElementClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        var discountCode;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              discountCode = this.getAttribute('discount-code');
              _context.prev = 1;
              _context.next = 4;
              return navigator.clipboard.writeText(discountCode);
            case 4:
              this.classList.add('copied');
              setTimeout(function () {
                _this.classList.remove('copied');
              }, 2000);
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error('Failed to copy discount code', _context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 8]]);
      }));
      function onDiscountElementClick() {
        return _onDiscountElementClick.apply(this, arguments);
      }
      return onDiscountElementClick;
    }()
  }]);
  return JoPromoBanner;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('jo-promo-banner', JoPromoBanner);

/***/ }),

/***/ "./src/js/modules/jo-section-heading.js":
/*!**********************************************!*\
  !*** ./src/js/modules/jo-section-heading.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var JoSectionHeading = /*#__PURE__*/function (_HTMLElement) {
  _inherits(JoSectionHeading, _HTMLElement);
  var _super = _createSuper(JoSectionHeading);
  function JoSectionHeading() {
    _classCallCheck(this, JoSectionHeading);
    return _super.apply(this, arguments);
  }
  _createClass(JoSectionHeading, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.headingContainers = this.querySelectorAll('.heading-container');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.headingContainers.length > 0) {
        document.addEventListener('sc:product-collection-filter:changed', this.onFilterChanged.bind(this));
      }
    }
  }, {
    key: "onFilterChanged",
    value: function onFilterChanged(e) {
      var currentCollection = e.detail.value;
      this.headingContainers.forEach(function (container) {
        if (currentCollection === container.dataset.collectionHandle || !currentCollection && container.dataset.collectionHandle === 'default') {
          container.classList.remove('hidden');
        } else {
          container.classList.add('hidden');
        }
      });
    }
  }]);
  return JoSectionHeading;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('jo-section-heading')) {
  customElements.define('jo-section-heading', JoSectionHeading);
}

/***/ }),

/***/ "./src/js/modules/jo-size-label.js":
/*!*****************************************!*\
  !*** ./src/js/modules/jo-size-label.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var JoSizeLabel = /*#__PURE__*/function (_HTMLElement) {
  _inherits(JoSizeLabel, _HTMLElement);
  var _super = _createSuper(JoSizeLabel);
  function JoSizeLabel() {
    _classCallCheck(this, JoSizeLabel);
    return _super.apply(this, arguments);
  }
  _createClass(JoSizeLabel, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _this$popup, _this$popup2;
      this.popup = this.querySelector('[data-size-label-popup]');
      this.popupContent = (_this$popup = this.popup) === null || _this$popup === void 0 ? void 0 : _this$popup.querySelector('[data-popup-content]');
      this.popupCloseButton = (_this$popup2 = this.popup) === null || _this$popup2 === void 0 ? void 0 : _this$popup2.querySelector('[data-popup-close]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('click', this.onClick.bind(this));
      this.popup.addEventListener('click', this.onPopupClick.bind(this));
      this.popupCloseButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      this.handleOpenPopup(e);
    }

    /** POPUP METHODS **/
  }, {
    key: "handleOpenPopup",
    value: function handleOpenPopup(e) {
      e.preventDefault();
      if (!this.popup) return;
      this.popup.classList.add('is-active');
    }
  }, {
    key: "onPopupClick",
    value: function onPopupClick(e) {
      e.stopPropagation();
      if (this.popupContent && this.popupContent.contains(e.target)) {
        return;
      }

      // Klick außerhalb des Dialogs (also auf den Hintergrund / Container) → schließen
      this.closePopup();
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.popup.classList.remove('is-active');
    }
  }]);
  return JoSizeLabel;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('jo-size-label')) {
  customElements.define('jo-size-label', JoSizeLabel);
}

/***/ }),

/***/ "./src/js/modules/jo-sticky-add-to-cart-bar.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/jo-sticky-add-to-cart-bar.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var JoStickyAddToCartBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(JoStickyAddToCartBar, _HTMLElement);
  var _super = _createSuper(JoStickyAddToCartBar);
  function JoStickyAddToCartBar() {
    _classCallCheck(this, JoStickyAddToCartBar);
    return _super.apply(this, arguments);
  }
  _createClass(JoStickyAddToCartBar, [{
    key: "active",
    get: /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    }
  }, {
    key: "setActive",
    value: function setActive(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.observerType = this.getAttribute('observer-type');
      this._attachSelectors();
      this._attachListeners();
      if (this.defaultBtnAddToCart) {
        this.cloneBtnAddToCart();
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.defaultBtnAddToCart = document.querySelector('[data-add-to-cart]');
      this.btnAddToCartContainer = this.querySelector('[data-atc-container]');
      this.selectItems = this.querySelectorAll('.select-container select');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      document.addEventListener('variant:change', this.onVariantChange.bind(this));
      this.observeElement(this.defaultBtnAddToCart);

      // Add change listeners for each <select> element
      this.selectItems.forEach(function (select) {
        select.addEventListener('change', _this.onSelectChange.bind(_this));
      });
    }
  }, {
    key: "cloneBtnAddToCart",
    value: function cloneBtnAddToCart() {
      // Remove old button and its event listener if it exists
      if (this.btnAddToCart) {
        this.btnAddToCart.removeEventListener('click', this.onBtnAddToCart);
        this.btnAddToCartContainer.removeChild(this.btnAddToCart);
      }

      // Disconnect the text observer if it exists
      if (this.textObserver) {
        this.textObserver.disconnect();
      }

      // Clone the button element
      var clonedBtn = this.defaultBtnAddToCart.cloneNode(true);

      // Append the cloned button to the container
      if (this.btnAddToCartContainer) {
        this.btnAddToCartContainer.appendChild(clonedBtn);
        this.btnAddToCart = clonedBtn;
        this.btnAddToCart.addEventListener('click', this.onBtnAddToCart.bind(this));

        // Re-observe the text of the new cloned button
        this.observePreOrderButton();
      }
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var _this2 = this;
      var currentlySelectedValues = e.detail.currentlySelectedValues;

      // Synchronize select items based on currently selected values
      currentlySelectedValues.forEach(function (item) {
        // Find the <select> element that matches the option index using 'index' attribute
        var selectElement = Array.from(_this2.selectItems).find(function (select) {
          return select.getAttribute('data-option-index') === item.index;
        });
        if (selectElement) {
          // Find and select the matching option
          Array.from(selectElement.options).forEach(function (option) {
            option.selected = option.value === item.value;
          });
        }
      });
      this.cloneBtnAddToCart();
    }
  }, {
    key: "onSelectChange",
    value: function onSelectChange() {
      // Iterate over select items to get selected values
      this.selectItems.forEach(function (select) {
        var selectedValue = select.value;
        var optionIndex = select.getAttribute('data-option-index');
        var radioButton = document.querySelector(".variant-input input[data-index=\"".concat(optionIndex, "\"][value=\"").concat(selectedValue, "\"]"));

        // Set the radio button as checked if it exists
        if (radioButton) {
          //radioButton.checked = true;
          radioButton.click();
        }
      });
    }
  }, {
    key: "onBtnAddToCart",
    value: function onBtnAddToCart() {
      this.defaultBtnAddToCart.click();
    }

    /*** OBSERVE HANDLING ***/
  }, {
    key: "observeElement",
    value: function observeElement(element) {
      var observer;
      if (this.observerType === 'not-visible') {
        observer = new IntersectionObserver(this.handleIntersection.bind(this));
      } else {
        observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        });
      }
      observer.observe(element);
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entries) {
      var _this3 = this;
      // show sticky bar, whenever not visible
      if (this.observerType === 'not-visible') {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            // hide sticky bar
            _this3.setActive('false');
            document.body.classList.remove('jo-sticky-atc-bar-visible');
          } else {
            // show sticky bar
            _this3.setActive('true');
            document.body.classList.add('jo-sticky-atc-bar-visible');
          }
        });
      } else {
        // show sticky bar, after selector scroll
        var dif = entries[0].boundingClientRect.top;
        if (dif < 0) {
          if (entries[0].isIntersecting) {
            // entered viewport at the top edge, hence scroll direction is up
            this.setActive('true');
            document.body.classList.add('jo-sticky-atc-bar-visible');
          } else {
            // left viewport at the top edge, hence scroll direction is down
            this.setActive('true');
            document.body.classList.add('jo-sticky-atc-bar-visible');
          }
        } else {
          this.setActive('false');
          document.body.classList.remove('jo-sticky-atc-bar-visible');
        }
      }
    }

    /** PRE ORDER OBSERVER **/
  }, {
    key: "observePreOrderButton",
    value: function observePreOrderButton() {
      var _this4 = this;
      // Create a MutationObserver to observe text changes
      this.textObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            _this4.btnAddToCart.textContent = _this4.defaultBtnAddToCart.textContent;
          }
        });
      });

      // Configure and start the observer
      this.textObserver.observe(this.defaultBtnAddToCart, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }]);
  return JoStickyAddToCartBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('jo-sticky-add-to-cart-bar', JoStickyAddToCartBar);

/***/ }),

/***/ "./src/js/modules/product-info-banner.js":
/*!***********************************************!*\
  !*** ./src/js/modules/product-info-banner.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProductInfoBanner = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductInfoBanner, _HTMLElement);
  var _super = _createSuper(ProductInfoBanner);
  function ProductInfoBanner() {
    _classCallCheck(this, ProductInfoBanner);
    return _super.apply(this, arguments);
  }
  _createClass(ProductInfoBanner, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.infoIconContainer = this.querySelector('[data-info-icon-container]');
      this.infoContent = this.querySelector('[data-info-content]');
      this.btnClose = this.querySelector('[data-close-content]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.infoIconContainer) {
        this.infoIconContainer.addEventListener('click', this.toggleInfoContent.bind(this));
      }
      if (this.btnClose) {
        this.btnClose.addEventListener('click', this.toggleInfoContent.bind(this));
      }
    }
  }, {
    key: "toggleInfoContent",
    value: function toggleInfoContent() {
      var isActive = this.infoContent.classList.contains('active');
      if (isActive) {
        this.infoContent.classList.remove('active');
        this._removeOutsideClickListener();
      } else {
        this.infoContent.classList.add('active');
        this._addOutsideClickListener();
      }
    }
  }, {
    key: "_addOutsideClickListener",
    value: function _addOutsideClickListener() {
      this._outsideClickListener = this._handleOutsideClick.bind(this);
      document.addEventListener('click', this._outsideClickListener);
    }
  }, {
    key: "_removeOutsideClickListener",
    value: function _removeOutsideClickListener() {
      document.removeEventListener('click', this._outsideClickListener);
      this._outsideClickListener = null;
    }
  }, {
    key: "_handleOutsideClick",
    value: function _handleOutsideClick(event) {
      if (!this.contains(event.target)) {
        this.toggleInfoContent(); // Close the content and remove the listener
      }
    }
  }]);
  return ProductInfoBanner;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('jo-product-info-banner', ProductInfoBanner);

/***/ }),

/***/ "./src/js/modules/sc-product-collection-filter.js":
/*!********************************************************!*\
  !*** ./src/js/modules/sc-product-collection-filter.js ***!
  \********************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ScProductCollectionFilter = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ScProductCollectionFilter, _HTMLElement);
  var _super = _createSuper(ScProductCollectionFilter);
  function ScProductCollectionFilter() {
    var _this;
    _classCallCheck(this, ScProductCollectionFilter);
    _this = _super.call(this);
    _this.COLLECTION_FILTER_ITEM = ".sc-product-collection-filter-categories-item";
    _this.PRODUCT_GRID_ITEM = ".grid__item.grid-product[data-collection-handle]";
    _this.CTA_ITEM = ".sc-product-collection-filter-cta";
    _this.BASE_COLLECTION_HANDLE = "data-base-collection-handle";
    _this.filters = _this.querySelectorAll(_this.COLLECTION_FILTER_ITEM);
    _this.allProducts = document.querySelectorAll(_this.PRODUCT_GRID_ITEM);
    _this.baseCollectionHandles = _this.getAttribute(_this.BASE_COLLECTION_HANDLE);
    return _this;
  }
  _createClass(ScProductCollectionFilter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Initiales Ausblenden der CTAs
      this.updateCTAVisibility();
      this.filters.forEach(function (filter) {
        filter.addEventListener("click", function (e) {
          var target = e.target.closest(_this2.COLLECTION_FILTER_ITEM);
          e.preventDefault();
          _this2.setFiltersInactive(target);
          target.classList.toggle("active");
          if (target.classList.contains("active")) {
            var collectionHandle = target.dataset.collectionHandle;
            var baseCollectionHandles = _this2.baseCollectionHandles.split(",");
            var _iterator = _createForOfIteratorHelper(baseCollectionHandles),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var baseCollectionHandle = _step.value;
                var products = document.querySelectorAll(".sc-product-collection-filter-flex[data-collection-handle=\"".concat(baseCollectionHandle, "\"] [data-product-handle]"));
                products.forEach(function (product) {
                  var productCollectionHandles = product.dataset.collectionHandle.split(",");
                  if (productCollectionHandles.includes(collectionHandle)) {
                    product.style.display = "block";
                  } else {
                    product.style.display = "none";
                  }
                });
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _this2.currentCollectionHandle = target.dataset.collectionHandle;
          }
          if (_this2.querySelectorAll("".concat(_this2.COLLECTION_FILTER_ITEM, ".active")).length === 0) {
            _this2.allProducts.forEach(function (product) {
              product.style.display = "block";
            });
            _this2.currentCollectionHandle = null;
          }

          // Nach jedem Filter-Click CTAs aktualisieren
          _this2.updateCTAVisibility();
          if (window.AOS) {
            AOS.refresh();
          }
          console.log(target);
          document.dispatchEvent(new CustomEvent('sc:product-collection-filter:changed', {
            bubbles: true,
            detail: {
              value: _this2.currentCollectionHandle
            }
          }));
        });
      });
    }
  }, {
    key: "setFiltersInactive",
    value: function setFiltersInactive(target) {
      this.filters.forEach(function (filter) {
        if (filter !== target) {
          filter.classList.remove("active");
        }
      });
    }
  }, {
    key: "updateCTAVisibility",
    value: function updateCTAVisibility() {
      var _this3 = this;
      // Alle sichtbaren Produkt-Grid-Items zähle
      var collectionFilterSections = document.querySelectorAll("[data-collection-filter]");
      var _iterator2 = _createForOfIteratorHelper(collectionFilterSections),
        _step2;
      try {
        var _loop = function _loop() {
          var collectionFilterSection = _step2.value;
          var ctas = document.querySelectorAll("[data-collection-filter][data-collection-handle='".concat(collectionFilterSection.dataset.collectionHandle, "'] ").concat(_this3.CTA_ITEM));
          ctas.forEach(function (cta) {
            var visibleProducts = Array.from(_this3.allProducts).filter(function (product) {
              productCollections = product.dataset.collectionHandle.split(",");
              return product.style.display !== "none" && productCollections.includes(collectionFilterSection.dataset.collectionHandle);
            });
            var visibleCount = visibleProducts.length; // Alle CTA-Elemente holen
            var pos = parseInt(cta.getAttribute("data-position"), 10);
            if (pos - 1 > visibleCount) {
              cta.style.display = "none";
            } else {
              cta.style.display = "";
            }
          });
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
  return ScProductCollectionFilter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!window.customElements.get("sc-product-collection-filter")) {
  window.customElements.define("sc-product-collection-filter", ScProductCollectionFilter);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _imports_slider_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./imports/slider-component */ "./src/js/imports/slider-component.js");
/* harmony import */ var _imports_slider_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_imports_slider_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_product_video_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-product-video-component */ "./src/js/modules/ed-product-video-component.js");
/* harmony import */ var _modules_ed_product_video_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_video_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-free-gift-handling */ "./src/js/modules/ed-free-gift-handling.js");
/* harmony import */ var _modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-cart-upsell */ "./src/js/modules/ed-cart-upsell.js");
/* harmony import */ var _modules_product_info_banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/product-info-banner */ "./src/js/modules/product-info-banner.js");
/* harmony import */ var _modules_product_info_banner__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_product_info_banner__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_jo_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/jo-sticky-add-to-cart-bar */ "./src/js/modules/jo-sticky-add-to-cart-bar.js");
/* harmony import */ var _modules_jo_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_jo_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_jo_promo_banner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/jo-promo-banner */ "./src/js/modules/jo-promo-banner.js");
/* harmony import */ var _modules_jo_promo_banner__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_jo_promo_banner__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_sc_product_collection_filter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/sc-product-collection-filter */ "./src/js/modules/sc-product-collection-filter.js");
/* harmony import */ var _modules_sc_product_collection_filter__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_sc_product_collection_filter__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _modules_jo_section_heading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/jo-section-heading */ "./src/js/modules/jo-section-heading.js");
/* harmony import */ var _modules_jo_section_heading__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_jo_section_heading__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_jo_image_slider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/jo-image-slider */ "./src/js/modules/jo-image-slider.js");
/* harmony import */ var _modules_jo_image_slider__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modules_jo_image_slider__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _modules_jo_gwp_main__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/jo-gwp-main */ "./src/js/modules/jo-gwp-main.js");
/* harmony import */ var _modules_jo_size_label__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/jo-size-label */ "./src/js/modules/jo-size-label.js");
/* harmony import */ var _modules_jo_size_label__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_modules_jo_size_label__WEBPACK_IMPORTED_MODULE_11__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/












})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;